<nav class="navbar navbar-default navbar-fixed-top">
  <div class="container-fluid">
    <div class="navbar-header d-flex align-items-center">
      <img class="navbar-brand"
           src="https://res.cloudinary.com/finzy/image/upload/v1702367764/finzy_logo_full_ca8aib.svg"
           alt="finzy logo - Home">

      <div class="brand-separator mt-1 mr-1" *ngIf="secondaryLogoUrl"></div>
      <img [src]="secondaryLogoUrl" class="secondary-logo ml-2" *ngIf="secondaryLogoUrl">
    </div>
  </div>
</nav>
